// src/store/index.js

const state = {
    message: '',
    type: 'info', // 'success', 'error', 'warning', 'info'
    show: false
};

const mutations = {
    showMessage(state, { message, type = 'success' }) {
        state.message = message;
        state.type = type;
        state.show = true;
    },
    hideMessage(state) {
        state.show = false;
        state.message = '';
    }
};

export default {
    namespaced: true,
    state,
    mutations
};